// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import './theme.js';
import store from './store.js';

import VueResource from 'vue-resource';
import VueTruncate from 'vue-truncate-filter';
import VueTimeago from 'vue-timeago';
import './directives.js';

Vue
  .use(VueResource)
  .use(VueTruncate)
  .use(VueTimeago, {
    locale: 'de',
    locales: {
      de: require('date-fns/locale/de')
    }
  })
;

Vue.config.productionTip = false;
Vue.url.options.root = process.env.API_URL;


(() => {
  const hosts = {
    development: 'http://localhost:2801',
    production: 'https://api.jagdnews.de',
  };

  Vue.url.options.root = hosts[process.env.NODE_ENV];
})();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  async created () {
    this.$revived = false;
    
    if (['production'].includes(process.env.NODE_ENV)) {
      const tag = document.createElement('script');
      tag.setAttribute('src', 'https://servedby.adhunter.de/www/delivery/asyncjs.php');
      tag.onload = () => {
        this.$revived = true;
        this.$emit('revive-loaded');
      };
      document.head.appendChild(tag);
    }

    if (!this.$store.getters.deviceId || this.$store.getters.deviceId === '') {
      this.$store.commit('setDeviceId', '_' + Math.random().toString(36).substr(2, 9));
    }
  }
});
